import { axiosObject } from "../config";

export default function getUser() {
  return new Promise((resolve, reject) => {
    let uri = "access/user";

    axiosObject
      .get(uri)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
